<script lang="ts">
  import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';

  const { icon }: { icon: IconDefinition } = $props();

  const [width, height, , , path] = $derived(icon.icon);
</script>

<svg class="icon" viewBox="0 0 {width} {height}" aria-hidden="true" focusable="false">
  {#each Array.isArray(path) ? path : [path] as d (d)}
    <path {d} fill="currentColor" />
  {/each}
</svg>

<style>
  .icon {
    display: block;
    flex: none;
    width: 1em;
    height: 1em;
  }
</style>
